import { PhoneInput } from './ui/PhoneInput';

interface OptionalInfoFormProps {
  phoneNumber: string;
  facebookName: string;
  discordHandle: string;
  marketingConsent: boolean;
  onPhoneNumberChange: (value: string) => void;
  onFacebookNameChange: (value: string) => void;
  onDiscordHandleChange: (value: string) => void;
  onMarketingConsentChange: (value: boolean) => void;
  disabled?: boolean;
}

export default function OptionalInfoForm({
  phoneNumber,
  facebookName,
  discordHandle,
  marketingConsent,
  onPhoneNumberChange,
  onFacebookNameChange,
  onDiscordHandleChange,
  onMarketingConsentChange,
  disabled = false,
}: OptionalInfoFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-sl-text mb-1">
          Phone Number (Optional)
        </label>
        <PhoneInput
          value={phoneNumber}
          onChange={(number) => onPhoneNumberChange(number)}
          placeholder="Enter your phone number"
          disabled={disabled}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-sl-text mb-1">
          Facebook Name (Optional)
        </label>
        <input
          type="text"
          value={facebookName}
          onChange={(e) => onFacebookNameChange(e.target.value)}
          placeholder="Enter your Facebook name"
          className="w-full border border-sl-surface-2 rounded-lg px-3 py-2 text-sm bg-sl-surface text-sl-text focus:outline-none focus:border-sl-accent"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-sl-text mb-1">
          Discord Handle (Optional)
        </label>
        <input
          type="text"
          value={discordHandle}
          onChange={(e) => onDiscordHandleChange(e.target.value)}
          placeholder="Enter your Discord handle"
          className="w-full border border-sl-surface-2 rounded-lg px-3 py-2 text-sm bg-sl-surface text-sl-text focus:outline-none focus:border-sl-accent"
        />
      </div>

      <div className="flex items-start gap-2 pt-2">
        <input
          type="checkbox"
          id="marketing-consent"
          checked={marketingConsent}
          onChange={(e) => onMarketingConsentChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-sl-surface-2 bg-sl-surface text-sl-accent focus:ring-2 focus:ring-sl-accent focus:ring-offset-0"
        />
        <label htmlFor="marketing-consent" className="text-sm text-slate-300 cursor-pointer">
          I agree to receive marketing communications and accept the{' '}
          <a
            href="https://getsnaplayer.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="text-cyan-400 hover:underline"
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            href="https://getsnaplayer.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-cyan-400 hover:underline"
          >
            Privacy Policy
          </a>
        </label>
      </div>
    </div>
  );
}
